/* eslint no-console: 0 */
/* eslint no-underscore-dangle: 0 */
import React from 'react';
import Suggestions from './Suggestions';
import SuggestionFragment from './SuggestionFragment';

import { getExternalResourceSuggestions } from '../../utilities/suggestionUtilities';

const ExternalResourceSuggestions = (props) => (
    <div className="suggestions external-suggestions">
        <Suggestions
            async
            getSuggestions={getExternalResourceSuggestions}
            selectSuggestion={props.insertExternalResourceEmbed}
            renderSuggestion={suggestion => <SuggestionFragment suggestion={suggestion} />}
            {...props}
        />
    </div>
);

export default ExternalResourceSuggestions;
